import './spinBtn.css';

const SpinBtn = ({
    largura,
    altura,
    cor,
    corDaBordaTop
}) => {
    return (
        <span
            className='spin'
            style={{ 
                width: largura, 
                height: altura,
                borderColor: cor, 
                borderTopColor: corDaBordaTop
            }}
        >
        </span>
    );
};

export default SpinBtn;